import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaUtensils, FaTooth, FaCut, FaTools, FaBuilding, FaHardHat } from 'react-icons/fa';

// Estilos para el componente
const ShowcaseContainer = styled.section`
  padding: 5rem 2rem;
  background-color: var(--light);
`;

const ShowcaseTitle = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
  color: var(--gray-dark);
`;

const ShowcaseSubtitle = styled.p`
  text-align: center;
  color: var(--gray);
  font-size: 1.1rem;
  margin-bottom: 3rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const TemplatesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const TemplateCard = styled.div`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const TemplateImage = styled.div`
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
  
  &::before {
    content: 'Ver Demo';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    color: var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1.2rem;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::before {
    opacity: 1;
  }
`;

const TemplateContent = styled.div`
  padding: 1.5rem;
`;

const TemplateCategory = styled.div`
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #e8f5e9;
  color: #2e7d32;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 30px;
  margin-bottom: 1rem;
`;

const TemplateTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--gray-dark);
`;

const TemplateDescription = styled.p`
  color: var(--gray);
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const TemplateButton = styled(Link)`
  display: inline-block;
  background-color: var(--blue);
  color: var(--white);
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #0056b3;
    text-decoration: none;
    color: var(--white);
  }
`;

const IconContainer = styled.div`
  font-size: 1.8rem;
  color: var(--blue);
  margin-right: 0.5rem;
  display: inline-block;
  vertical-align: middle;
`;

const CategoryWithIcon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const ComingSoonBanner = styled.div`
  background-color: #f5f5f5;
  border: 1px dashed #ccc;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  margin-top: 3rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const ComingSoonTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--gray-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    margin-right: 0.5rem;
    color: var(--blue);
  }
`;

const ComingSoonText = styled.p`
  color: var(--gray);
  font-size: 1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
`;

const templates = [
  {
    id: 'restaurante',
    title: 'Restaurante',
    category: 'Hostelería',
    icon: <FaUtensils />,
    description: 'Diseño elegante y funcional, perfecto para restaurantes y cafeterías que desean mostrar su menú y atraer reservas.',
    image: '/servicios/tipo-cliente/restaurantes-hero.webp',
    path: '/plantillas/restaurante'
  },
  {
    id: 'dentista',
    title: 'Clínica Dental',
    category: 'Salud',
    icon: <FaTooth />,
    description: 'Web profesional y confiable para dentistas, con sistema de citas, servicios y testimonios de pacientes.',
    image: '/servicios/tipo-cliente/dentistas-hero.webp',
    path: '/plantillas/dentista'
  },
  {
    id: 'peluqueria',
    title: 'Peluquería',
    category: 'Belleza',
    icon: <FaCut />,
    description: 'Diseño moderno y atractivo para salones de belleza y peluquerías, destacando servicios y galería de trabajos.',
    image: '/servicios/tipo-cliente/peluqueria-hero.webp',
    path: '/plantillas/peluqueria'
  },
  {
    id: 'taller',
    title: 'Taller Mecánico',
    category: 'Automoción',
    icon: <FaTools />,
    description: 'Web completa para talleres mecánicos, con secciones para servicios, precios, testimonios y solicitud de citas.',
    image: '/servicios/tipo-cliente/taller-hero.webp',
    path: '/plantillas/taller'
  },
  {
    id: 'arquitectos',
    title: 'Estudio de Arquitectura',
    category: 'Construcción',
    icon: <FaBuilding />,
    description: 'Diseño elegante y minimalista para estudios de arquitectura, perfecto para mostrar proyectos y servicios profesionales.',
    image: '/servicios/tipo-cliente/arquitectos-hero.webp',
    path: '/plantillas/arquitectos'
  },
  {
    id: 'constructora',
    title: 'Constructora',
    category: 'Construcción',
    icon: <FaHardHat />,
    description: 'Web corporativa para empresas constructoras, con secciones para proyectos destacados, servicios y solicitud de presupuestos.',
    image: '/servicios/tipo-cliente/constructora-hero.webp',
    path: '/plantillas/constructora'
  }
];

const TemplateShowcase: React.FC = () => {
  return (
    <ShowcaseContainer>
      <ShowcaseTitle>Algunos ejemplos de cómo podría ser tu nueva web a bajo coste</ShowcaseTitle>
      <ShowcaseSubtitle>
        Explora estas demos interactivas diseñadas para diferentes sectores. Cada una incluye 
        todas las funciones necesarias para destacar tu negocio en internet sin gastar una fortuna.
      </ShowcaseSubtitle>
      
      <TemplatesGrid>
        {templates.map(template => (
          <TemplateCard key={template.id}>
            <Link to={template.path}>
              <TemplateImage style={{ backgroundImage: `url(${template.image})` }} />
            </Link>
            <TemplateContent>
              <CategoryWithIcon>
                <IconContainer>{template.icon}</IconContainer>
                <TemplateCategory>{template.category}</TemplateCategory>
              </CategoryWithIcon>
              <TemplateTitle>{template.title}</TemplateTitle>
              <TemplateDescription>{template.description}</TemplateDescription>
              <TemplateButton to={template.path}>Ver Demo</TemplateButton>
            </TemplateContent>
          </TemplateCard>
        ))}
      </TemplatesGrid>
    </ShowcaseContainer>
  );
};

export default TemplateShowcase; 